import { Injectable } from '@angular/core';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest, HttpResponse, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { ErrorHandlerService } from '../services/error-handler.service';

@Injectable()
export class LoadingInterceptor implements HttpInterceptor {

  constructor(
    private errorHandlerService: ErrorHandlerService
  ) {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {


    return next.handle(request).pipe(
      map(event => {
        if (event instanceof HttpResponse) {
          const skStatus = event.body?.status?.toLowerCase(); // Skillcheck responses are special
          if(skStatus){
            if (skStatus === 'success') {
              let normalizedResult = event.body.result || event.body.results;
              if (typeof normalizedResult === 'string') {
                if (normalizedResult.indexOf('Internal Server Error:') < 0) {
                  try{
                    normalizedResult = JSON.parse(normalizedResult);
                  } catch(e){
                    // Do nothing
                  }
                  return event.clone({ body: { ...event.body, result: normalizedResult } });
                } else {
                  return event;
                }
              }
            } else {
              this.errorHandlerService.handleError(new HttpErrorResponse({
                error: event.body,
                headers: event.headers,
                status: event.status,
                statusText: event.statusText || 'Error',
                url: event.url || undefined
              }));
            }
          }
        }
        return event;
      }),
      catchError((error: HttpErrorResponse) => {
        this.errorHandlerService.handleError(error, error.error?.result);
        return throwError(() => error);
      })
    );
  }

}
